import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
// import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common'; 

import { LoginComponent } from './login.component';
import { NoAuthGuard } from './no-auth-guard.service';
//import { SharedModule } from '../shared';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

const loginRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: 'login',
    component: LoginComponent,
    data: { title: "what's up" },
    canActivate: [NoAuthGuard]
  },
]);

@NgModule({
  imports: [
    loginRouting,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [
    LoginComponent
  ],

  providers: [
    NoAuthGuard,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class LoginModule {}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/login/login.module.ts